<template>
  <form style="min-height: 60vh;width: 500px; margin: auto; background-color: #8A8D91;">
    <template>
    <div style="width: 100%; margin: auto; background-color: #8A8D91;" >
        <div style="width: 500px; height: 75px; margin-bottom: 25px; margin-left: auto; margin-right: auto;"><img src="https://mobipest.eu/wp-content/uploads/2021/01/mobipest_logo.png" style="width: 100%; height: 100%;"></div>
        <div  style="width: 500px; margin: auto; margin-top: 50px;"><h6>{{errors.join(", ")}}</h6></div>
        <div class="row" style="margin-top: 0.25rem; margin-bottom: 0.25rem; text-align: right;" v-if="alert == undefined">
            <div class="col s4" style="text-align: right; margin-top: 0.75rem; margin-bottom: 0.25rem;">{{ $t('register.password') }} </div>
            <div class="input-field inline col s4" style="margin-top: 0.25rem;margin-bottom: 0.25rem;width: 300px;"><input type="password" v-model="password" /></div>
        </div>
        <div class="row" style="margin-top: 0.25rem; margin-bottom: 0.25rem; text-align: right;" v-if="alert == undefined">
            <div class="col s4" style="text-align: right; margin-top: 0.75rem; margin-bottom: 0.25rem;">{{ $t('register.password_confirm') }} </div>
            <div class="input-field inline col s4" style="margin-top: 0.25rem;margin-bottom: 0.25rem;width: 300px; "><input type="password" v-model="password_confirm"  v-on:blur="validatePasswordField"/></div>
            <div class="col s6" style="text-align: right; margin-top: 0.75rem; margin-bottom: 0.25rem;"><span style="color:#c22026;">{{passwordConfirmError}}</span></div>
        </div>
    </div>
    </template>
        <div class="row" style="margin-bottom: 0px;" v-if="alert == undefined">
            <div class="col s8 offset-s4" style="margin-bottom: 0px;">
                <div style="width: 500px;"><label>
                        <input type="checkbox" disabled="true" :checked="hasAtLeastDigit()" />
                        <span>{{$t('register.at_least_one_digit')}}</span>
                    </label></div>
                <div style="width: 500px;"><label>
                        <input type="checkbox" disabled="true" :checked="hasAtLeastSpecialChar()" />
                        <span>{{$t('register.at_least_one_special_character')}}</span>
                    </label></div>
                <div style="width: 500px;"><label>
                        <input type="checkbox" disabled="true" :checked="hasAtLeastOneUpperAndLower()" />
                        <span>{{$t('register.at_least_one_uppercase_one_lowercase')}}</span>
                    </label></div>
                <div style="width: 500px;"><label>
                        <input type="checkbox" disabled="true"  :checked="hasAtLeastEightChars()" />
                        <span>{{$t('register.at_least_eight_characters')}}</span>
                    </label></div>
            </div>
        </div>
      <div class="row" style="margin-top: 0.25rem; margin-bottom: 0.25rem; text-align: right;">
            <div class="col offset-s2 s2" style="text-align: right;">
                <p>
                    <a :disabled="isValid() == false" v-on:click="register_sent()" class="waves-effect waves-light btn-large" style="margin-top: 0.25rem; margin-bottom: 0.25rem; background-color: #C22026; text-transform: initial;">
                        <div v-if="remembering" class="preloader-wrapper small active">
                            <div class="spinner-layer spinner-red-only">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="gap-patch">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                        {{remembering == false ? $t('menu.send') : ""}}
                    </a>
                </p>
            </div>
        </div>
         <div class="row" style="margin-top: 0.25rem; margin-bottom: 0.25rem; text-align: right;">
            <div class="col offset-s2 s2">
                <p>
                    <a  href="#/login" class="waves-effect waves-light btn-large" style="background-color: #DADADA; text-transform: initial; height: 48px;">{{ $t('menu.cancel') }}</a>
                </p>
            </div>
        </div>
</form>
</template>

<script>
import axios from 'axios';
export default {
		data: function() {
	        return {
	            password: "",
	            password_confirm: "",
                passwordConfirmError: "",
                data_agreement: false,
                registering: false,
                registered: false,
                offers: false,
                newsletter: false,
                recaptcha: "",
                invitation_token: '',
                anonymous_stats: false,
                disclaimer: false,
                nocaptchaError: false,
                remembering: false,
                errors: [],
                token: ""
	        }
    	},
        props: {
            alert: String
        },
        mounted: function(){
            if(this.$parent.logged_in){
                this.$router.push('/desktop');
            }
            this.token = this.$route.query.reset_token;
        },
        created: function(){
        },
        methods: {
        	hasAtLeastDigit: function() {
            return /\d/.test(this.password);
        },
        hasAtLeastSpecialChar: function() {
            return /[!@#$%^&*.?]/.test(this.password);
        },
        hasAtLeastOneUpperAndLower: function() {
            return /[A-Z]/.test(this.password) && /[a-z]/.test(this.password)
        },
        hasAtLeastEightChars: function() {
            return this.password.length >= 8;
        },
        isValid: function() {
            return this.password == this.password_confirm && this.hasAtLeastDigit() && this.hasAtLeastSpecialChar() && this.hasAtLeastOneUpperAndLower() && this.hasAtLeastEightChars();
        },
        validatePasswordField: function(){
            if(this.password != this.password_confirm){
                this.passwordConfirmError = this.$t('reset_password.no_identical_password')
            }else{
                this.passwordConfirmError = ""
            }
        },
        reset(){
            this.$emit('cancel');
            this.$emit('reset');
        },
        cancel(){
            this.$emit('cancel');
        },
        register_sent(){
            var that = this;
            if(this.disclaimer){    
                this.remembering = true;
                axios.put('/users/password.json', {
                    "user": {
                        "password": this.password,
                        "password_confirmation": this.password_confirm,
                        "reset_password_token": this.token
                    }
                }).then(response => {
                        this.remembering = false;
                        this.$router.push('/login');
                }).catch(function(reason) {
                   that.remembering = false;
                   if(_.isUndefined(reason.response.data['errors']) == false){
                        that.errors = _.flatten(_.values(reason.response.data['errors']));
                   }
                });
            }else{
                this.disclaimer = true;
            }
        }
    },
}
</script>

<style scoped>
.login_button {
    color: red;
}

p {
    font-size: 1em;
    text-align: center;
}

nav {
    background-color: #8A8D91;
    height: 100px;
}

img {
    width: 50px;
    height: 50px;
}

nav a {
    margin: 15px;
    font-size: 18px;
}

nav i {
    font-size: initial;
    height: initial;
    line-height: initial;
    padding-top: 6px;
}

nav li.menuitems {
    text-transform: uppercase;
    width: 130px;
    text-align: center !important;
    margin-top: 16px;
    background-color: #BEBBBB;
    height: 84px;
}

nav ul li {
    margin-top: 14px;
}

li.menuitems a {
    color: black !important;
    margin: 0px;
    padding: 0px;
    height: 84px;
    line-height: 1.5;
}

.menuitems i.material-icons {
    font-size: 48px !important;
}

nav li.selected {
    background-color: #C22026;
    height: 84px;

}

.btn-large,
.btn {
    border-radius: 8px !important;
    color: black;
}

.nav-wrapper {
    color: black !important;
}

.logout {
    background-color: #C22026 !important;
}

.upmenu {
    width: 1170px;
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    letter-spacing: 2.5px;
}

form .btn-large {
    width: 338px;
}

.grayed {
    background-color: rgb(138, 141, 145);
}

.page-footer {
    background-color: rgb(218, 218, 218);
    color: black !important;
}

.page-footer h6 {
    font-weight: bold;
}

h6 {
    color: #C22026 !important;
}

.page-footer p {
    text-align: left;
}

label {
    color: black;
}

i.material-icons {
    font-size: 16px !important;
}

.input-field.inline input {
    margin-bottom: initial;
}
.btn-large .preloader-wrapper {
    margin-top: 10px !important;
}
.btn-large{
    background-color: #DADADA;
}
.btn-large:disabled{
    background-color: #DADADA !important;
}
/deep/ .g-recaptcha div{
    margin: auto !important;
}
</style>
